export const BACKGROUND_COLORS = {
    step1: '#5C6BC0',
    step2: '#3F51B5',
    step3: '#303F9F',
    step4: '#283593',
    step5: '#1A237E'
  };
  
  export const STEPS = [1, 2, 3, 4, 5];
  
  export const INITIAL_LOADING_STATES = {
    analysis: false,
    submission: false
  };
  
